import axios from 'axios';
import { motion } from 'framer-motion';
import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import MotionNavLink from '../../MotionLink';
import { endpoint } from '../../../resource/Constant';
const ContactUs = () => {
  const [errors, setErrors] = useState({});
  const [submitionSuccess, setSubmitionSuccess] = useState(false);
  const [submitionFailure, setSubmitionFailure] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    const data = {
      name: e.target.name.value.trim(),
      phone: e.target.phone.value.trim(),
      email: e.target.email.value.trim(),
      subject: e.target.subject.value.trim(),
      yourmessage: e.target.message.value.trim()
    };

    const newErrors = {};

    if (!/^\d{10}$/.test(data.phone)) {
      newErrors.phone = 'Phone number must be exactly 10 digits.';
    }

    if (data.subject.length < 10) {
      newErrors.subject = 'Subject must be at least 10 characters.';
    }

    if (data.yourmessage.length < 10) {
      newErrors.yourmessage = 'Message must be at least 10 characters.';
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      setLoading(true);
      const submit = async () => {
        axios
          .post(`${endpoint}/api/contactformsubmit`, { ...data })
          .then((res) => {
            setSubmitionSuccess(true);
          })
          .catch((error) => {
            setSubmitionFailure(true);
          })
          .finally(() => {
            e.target.reset();
          });
      };
      submit();
    }
  };
  return (
    <div role="main" className="main">
      <section
        className="page-header page-header-modern page-header-background bg-color-dark p-relative z-index-1 lazyload"
        style={{
          backgroundImage: `url('img/mine/Contactus.png')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <motion.span
          className="custom-circle custom-circle-1 bg-color-light custom-circle-blur"
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.4, delay: 0.4 }}
        ></motion.span>
        <motion.span
          className="custom-circle custom-circle-2 bg-color-primary"
          initial={{ scale: 0 }}
          whileInView={{ scale: 1 }}
          transition={{ duration: 0.5, delay: 0.5 }}
        ></motion.span>
        <motion.span
          className="custom-circle custom-circle-3 bg-color-primary"
          initial={{ scale: 0 }}
          whileInView={{ scale: 1 }}
          transition={{ duration: 0.6, delay: 0.6 }}
        ></motion.span>
        <div className="container">
          <div className="row mt-5">
            <div className="col">
              <ul className="breadcrumb breadcrumb-light custom-title-with-icon-primary d-block">
                <li>
                  <NavLink to="/">Home</NavLink>
                </li>
                <li className="active">Contact Us</li>
              </ul>
              <h1 className="custom-text-10 font-weight-bold">Contact Us</h1>
            </div>
          </div>
        </div>
      </section>

      <section className="mt-3 mt-xl-0 py-5 position-relative z-index-2">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <motion.h1
                className="d-block w-100 text-color-dark py-4 custom-text-10 font-weight-bold text-center mb-4 pb-3"
                initial={{ opacity: 0, x: 50 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.2 }}
              >
                CONTACT US
                <span className="text-color-primary">.</span>
              </motion.h1>
              <div className="d-flex flex-row flex-wrap align-items-center justify-content-center mb-4 pb-3">
                <motion.span
                  className="d-flex flex-column flex-md-row text-center text-md-start px-5 px-md-0 mb-4 mb-md-0 align-items-center custom-text-5 font-weight-medium"
                  initial={{ opacity: 0, x: 50 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 0.4 }}
                >
                  <i className="far fa-envelope text-color-primary text-4 me-2"></i>
                  <NavLink to="info@gunadhyasoft.com" className="text-color-default">
                    info@gunadhyasoft.com
                  </NavLink>
                </motion.span>
                <motion.span
                  className="d-flex flex-column flex-md-row text-center text-md-start px-5 px-md-0 align-items-center custom-text-5 font-weight-medium"
                  initial={{ opacity: 0, x: 50 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 0.6 }}
                >
                  <i className="far fa-clock text-color-primary text-4 ms-md-4 me-md-2"></i>
                  Mon - Fri 10l x:00am - 8:00pm / Saturday-Sunday - CLOSED
                </motion.span>

                <motion.span
                  className="d-flex flex-column flex-md-row text-center text-md-start px-5 px-md-0 align-items-center custom-text-5 font-weight-medium"
                  initial={{ opacity: 0, x: 50 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 0.6 }}
                >
                  <i className="fas fa-phone text-color-primary text-4 ms-md-4 me-md-2"></i>
                  IN : +91 91300 81345
                </motion.span>
                <motion.span
                  className="d-flex flex-column flex-md-row text-center text-md-start px-5 px-md-0 align-items-center custom-text-5 font-weight-medium"
                  initial={{ opacity: 0, x: 50 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 0.6 }}
                >
                  <i className="fas fa-phone text-color-primary text-4 ms-md-4 me-md-2"></i>
                  IN : +91 2041246162
                </motion.span>
                <motion.span
                  className="d-flex flex-column flex-md-row text-center text-md-start px-5 px-md-0 align-items-center custom-text-5 font-weight-medium"
                  initial={{ opacity: 0, x: 50 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 0.6 }}
                >
                  <i className="fas fa-phone text-color-primary text-4 ms-md-4 me-md-2"></i>
                  SG : +65 8191 2862
                </motion.span>
              </div>
              <motion.p
                className="custom-text-4 text-center"
                initial={{ opacity: 0, x: 50 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.8 }}
              >
                We are here to assist you! Whether you have a question about our services, need support, or want to collaborate, feel free
                to reach out. Our team is always ready to help.
                <br />
                Let’s connect and create something amazing together!
              </motion.p>
            </div>
          </div>

          <div className="row">
            <div className="col-xl-12 pt-lg-5 mt-4 position-relative">
              <div className="row px-3">
                {/* Los Angeles */}
                <motion.div
                  className="col-xl-12 me-0 overflow-hidden"
                  initial={{ opacity: 0, y: 50 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.2 }}
                >
                  <div className="row px-3 justify-content-center">
                    <div className="col-xl-6 me-0 overflow-hidden col-where-you-are-postal">
                      <div className="row justify-content-end p-relative h-100">
                        <img src="img/mine/contactUs2.png" className="img-fluid" />
                        {/* <div className="col-lg-6 bg-color-primary d-flex flex-column align-items-center justify-content-center col-where-you-are-postal-text position-relative py-5 py-lg-0">
                          <h4 className="text-color-light custom-text-9">Pune,India</h4>
                          <p className="mb-1 text-color-light custom-text-4">Mont Vert Zenith, Baner Rd</p>
                          <p className="mb-1 text-color-light custom-text-4">Riviresa Society, Baner</p>
                          <p className="mb-0 text-color-light custom-text-4">
                            <a href="tel:+1234567890" className="text-color-light">
                              91+ 9130081345
                            </a>
                          </p>
                          <p className="mb-1 text-color-light custom-text-4">Time 9am - 8pm</p>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </motion.div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="col-lg-12  px-4">
            {!submitionFailure && !submitionSuccess ? (
              <>
                <motion.h2
                  className="text-color-dark custom-text-10 font-weight-bold text-center pt-5 mt-5 mb-5"
                  initial={{ opacity: 0, y: 50 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.5 }}
                >
                  Send us a Message
                </motion.h2>
                <form className="contact-form" onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="form-group col-lg-6">
                      <input
                        type="text"
                        name="name"
                        placeholder="Your Name"
                        className="form-control py-4 px-4 rounded-0"
                        required
                        disabled={loading}
                      />
                    </div>
                    <div className="form-group col-lg-6">
                      <input
                        type="text"
                        name="phone"
                        placeholder="Phone Number"
                        className="form-control py-4 px-4 rounded-0"
                        disabled={loading}
                        required
                      />
                      {errors.phone && <span className="text-danger">{errors.phone}</span>}
                    </div>
                  </div>
                  <div className="row">
                    <div className="form-group col-lg-6">
                      <input
                        type="email"
                        name="email"
                        placeholder="E-mail Address"
                        disabled={loading}
                        className="form-control py-4 px-4 rounded-0"
                        required
                      />
                    </div>
                    <div className="form-group col-lg-6">
                      <input
                        type="text"
                        name="subject"
                        placeholder="Subject"
                        className="form-control py-4 px-4 rounded-0"
                        disabled={loading}
                        required
                      />
                      {errors.subject && <span className="text-danger">{errors.subject}</span>}
                    </div>
                  </div>
                  <div className="row">
                    <div className="form-group col">
                      <textarea
                        name="message"
                        placeholder="Your Message"
                        className="form-control py-4 px-4 rounded-0"
                        rows="8"
                        disabled={loading}
                        required
                      ></textarea>
                      {errors.message && <span className="text-danger">{errors.message}</span>}
                    </div>
                  </div>
                  <div className="row">
                    <div className="form-group col">
                      <button type="submit" className="btn btn-primary px-4 py-3" disabled={loading}>
                        {loading ? 'Submitting...' : 'Submit'}
                      </button>
                    </div>
                  </div>
                </form>
              </>
            ) : submitionSuccess ? (
              <>
                <motion.h2 
                  className="text-color-dark custom-text-10 font-weight-bold text-center pt-5 mt-5 mb-5"
                  initial={{ opacity: 0, y: 50 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.5 }}
                >
                  Thank's For Inquiry
                </motion.h2>
                <div className="row">
                  <div className="col-xl-12  position-relative">
                    <div className="row px-3">
                      {/* Los Angeles */}
                      <motion.div
                        className="col-xl-12 me-0 overflow-hidden"
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.2 }}
                      >
                        <div className="row px-3 justify-content-center">
                          <div className="col-xl-6 me-0 overflow-hidden col-where-you-are-postal">
                            <div className="row justify-content-center p-relative h-100 ">
                              <div className="text-success mb-3 justify-content-center p-relative text-center">
                                <i className="fas fa-check-circle" style={{ fontSize: '200px' }}></i>
                              </div>
                              <h4 className="text-color-dark font-weight-bold mb-3  text-center">Our team will get back to you shortly!</h4>

                              <div className="col-lg-6 d-flex align-items-center justify-content-start justify-content-lg-end mt-5 mt-lg-0">
                                <MotionNavLink
                                  to="/"
                                  className="btn btn-outline custom-btn-outline btn-light border-white rounded-0 px-4 py-3 text-color-dark text-color-hover-dark  custom-text-6 line-height-6 font-weight-semibold custom-btn-with-arrow"
                                  initial={{ opacity: 0, x: -50 }}
                                  whileInView={{ opacity: 1, x: 0 }}
                                  viewport={{ once: false, amount: 0.2 }}
                                  transition={{ duration: 0.6, delay: 0.6 }}
                                >
                                  Back To Home
                                </MotionNavLink>
                              </div>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              submitionFailure && (
                <>
                  <motion.h2
                    className="text-color-dark custom-text-10 font-weight-bold text-center pt-5 mt-5 mb-5"
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.5 }}
                  >
                    Thank's For Inquiry
                  </motion.h2>
                  <div className="row">
                    <div className="col-xl-12  position-relative">
                      <div className="row px-3">
                        <motion.div
                          className="col-xl-12 me-0 overflow-hidden"
                          initial={{ opacity: 0, y: 50 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{ delay: 0.2 }}
                        >
                          <div className="row px-3 justify-content-center">
                            <div className="col-xl-6 me-0 overflow-hidden col-where-you-are-postal">
                              <div className="row justify-content-center p-relative h-100 ">
                                <div className="text-success mb-3 justify-content-center p-relative text-center">
                                  <i className="fas fa-times-circle" style={{ fontSize: '200px', color: 'red' }}></i>
                                </div>
                                <h3 className="text-color-dark font-weight-bold mb-3  text-center">
                                  Thank you for reaching out! We'll get back to you as soon as possible!
                                </h3>

                                <div className="col-lg-6 d-flex align-items-center justify-content-start justify-content-lg-end mt-5 mt-lg-0">
                                  <MotionNavLink
                                    to="/"
                                    className="btn btn-outline custom-btn-outline btn-light border-white rounded-0 px-4 py-3 text-color-dark text-color-hover-dark  custom-text-6 line-height-6 font-weight-semibold custom-btn-with-arrow"
                                    initial={{ opacity: 0, x: -50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    viewport={{ once: false, amount: 0.2 }}
                                    transition={{ duration: 0.6, delay: 0.6 }}
                                  >
                                    Back To Home
                                  </MotionNavLink>
                                </div>
                              </div>
                            </div>
                          </div>
                        </motion.div>
                      </div>
                    </div>
                  </div>
                </>
              )
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactUs;
